"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
const number_1 = require("./number");
class IntegerSchema extends number_1.NumberSchema {
    expected() {
        return 'an integer';
    }
    validate(value, utils) {
        return (utils.normalizeValidateResult(super.validate(value, utils), value) ===
            true && utils_1.isInt(value));
    }
}
exports.IntegerSchema = IntegerSchema;
